import {
    BackgroundImage,
    Box,
    Button,
    Card,
    Container,
    Grid,
    Group,
    Image,
    Stack,
    Text,
    Title,
    useMantineTheme,
} from "@mantine/core";
import { Carousel } from "@mantine/carousel";
import { useMediaQuery, useScrollIntoView } from "@mantine/hooks";
import { REGISTRATION_PIXEL, USER_TYPE } from "helpers/constants";
import { Permission, useAuth } from "hooks/useAuth";
import { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
    ChevronRight,
} from "tabler-icons-react";
import { useCallback } from "react";
import Particles from "react-particles";
import { loadFull } from "tsparticles";
import CustomHeader from "components/Header/Header";
import { useListingAPI } from "api/useListingAPI";
import TransparencyAboveAllElse from "pages/MainLanding/TransparencyAboveAllElse";
import FAQ from "pages/MainLanding/FAQ";
import WhyWeExist from "pages/MainLanding/WhyWeExist";
import HowItWorks from "pages/MainLanding/HowItWorks";
import SupportedBy from "pages/MainLanding/SupportedBy";
import FeaturedOn from "pages/MainLanding/FeaturedOn";
import InPartnershipWith from "pages/MainLanding/InPartnershipWith";
import WhyPropmoth from "pages/MainLanding/WhyPropmoth";
import FeaturedAgencies from "pages/MainLanding/FeaturedAgencies";
import ListingsRiver from "pages/MainLanding/ListingsRiver";
import PropRequestRiver from "pages/MainLanding/PropRequestRiver";
import PartneredAgencies from "./PartneredAgencies";

export default function PotentialAgentLanding({ ReactPixel }: any) {
    const navigate = useNavigate();
    const { useGetMyPropRequests } = useListingAPI();
    const location = useLocation();
    const theme = useMantineTheme();
    const isMobile = useMediaQuery(`(max-width: ${theme.breakpoints.md})`);
    const isTablet = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`);
    const isXs = useMediaQuery(`(max-width: ${theme.breakpoints.xs})`);
    const showMobileHeader = useMediaQuery(`(max-width: 780px)`);
    const { user } = useAuth(Permission.ANYONE);
    const { data, isLoading, error, refetch } = useGetMyPropRequests(
        user?.id.toString() || "0"
    );
    const { scrollIntoView, targetRef } = useScrollIntoView<
        HTMLDivElement,
        HTMLDivElement
    >();
    const { scrollIntoView: scrollWhyWeExist, targetRef: whyWeExist } =
        useScrollIntoView<HTMLDivElement, HTMLDivElement>();
    const [stepperIndex, setStepperIndex] = useState(0);

    const sidePadding = 24;

    const ctaNavigateLink = useMemo(() => {
        if (!!user.jwt) {
            if (user.userType === USER_TYPE.LISTER) {
                if (!!data && !isLoading) {
                    if (data.length > 0) {
                        return "/profile"
                    }
                }
                return "/become-an-agent/join";
            }

            if (user.userType === USER_TYPE.AGENT) {
                return "/profile?tab=leads";
            }
        }

        return "/become-an-agent/join";
        // return "/register/lister";
    }, [user, data, isLoading]);

    const particlesInit = useCallback(async (engine: any) => {
        // console.log(engine);
        // you can initiate the tsParticles instance (engine) here, adding custom shapes or presets
        // this loads the tsparticles package bundle, it's the easiest method for getting everything ready
        // starting from v2 you can add only the features you need reducing the bundle size
        await loadFull(engine);
    }, []);

    const particlesLoaded = useCallback(async (container: any) => {
        // await console.log(container);
    }, []);

    const SkewDivider = ({
        primaryColor,
        skewColor,
        skewZIndex,
        lineColor,
    }: {
        primaryColor: string;
        skewColor: string;
        skewZIndex?: number;
        lineColor?: string;
    }) => {
        return (
            <Box
                sx={{
                    background: primaryColor,
                    minHeight: 50,
                    width: "100%",
                    position: "relative",
                }}
            >
                <Box
                    sx={{
                        background: skewColor,
                        width: "100%",
                        height: 100,
                        position: "absolute",
                        left: 0,
                        top: "90%",
                        transform: `skew(0deg, -2deg) translateY(-50%)`,
                        zIndex: skewZIndex ?? 0,
                    }}
                >
                    <Container
                        size="1200px"
                        sx={{ height: "100%" }}
                    >
                        <Box
                            sx={{
                                height: "100%",
                            }}
                        />
                    </Container>
                </Box>
                <Container
                    size="1200px"
                    // px={sidePadding}
                    sx={{ height: "50px" }}
                >
                    <Box
                        sx={{
                            height: "100%",
                        }}
                    />
                </Container>
            </Box>
        );
    };

    useEffect(() => {
        // console.log(props)
        ReactPixel.pageView(null, [REGISTRATION_PIXEL])
    }, [])


    return (
        <Box pb={16}>
            <Box
                sx={{
                    position: "relative",
                    overflow: "hidden"
                }}
                mb={32}
            >
                <Box
                    sx={{
                        height: "100%",
                        zIndex: 100,
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                    }}
                >
                    <CustomHeader isLanding />
                </Box>
                <Box
                    sx={{
                        position: "absolute",
                        width: "180vw",
                        height: "125vw",
                        borderBottomLeftRadius: "50%",
                        borderBottomRightRadius: "50%",
                        bottom: 0,
                        left: 0,
                        overflow: "hidden",
                        [theme.fn.smallerThan("md")]: {
                            bottom: "18%",
                        },
                        [theme.fn.smallerThan("xs")]: {
                            top: "-30%",
                            bottom: "auto",
                        },
                    }}
                >
                    <Particles
                        id="tsparticles"
                        url="./particlesjs-config.json"
                        init={particlesInit}
                        loaded={particlesLoaded}
                    />
                </Box>
                <Container
                    size="1200px"
                    px={sidePadding}
                    sx={{
                        height: "100%",
                        width: "100%",
                        minHeight: "100vh",
                        [theme.fn.smallerThan("xs")]: {
                            minHeight: "80vh",
                        },
                    }}
                >
                    <Grid>
                        <Grid.Col sm={6} xs={12}>
                            <Stack
                                sx={{
                                    // maxWidth: 500,
                                    minHeight: "100vh",
                                    [theme.fn.smallerThan("sm")]: {
                                        maxWidth: "none",
                                    },
                                    [theme.fn.smallerThan("xs")]: {
                                        minHeight: "auto",
                                        paddingTop: "30%",
                                    },
                                    justifyContent: "center",
                                }}
                                spacing={16}
                            >
                                <Stack
                                    sx={(theme) => ({
                                        height: "100%",
                                        padding: `16px`,
                                        zIndex: 100,
                                        borderRadius: 8,
                                        [theme.fn.largerThan("xs")]: {
                                            paddingLeft: 0,
                                            marginTop: "20%",
                                        },
                                    })}
                                >
                                    <Text
                                        sx={(theme) => ({
                                            fontSize: "4.5vw",
                                            [theme.fn.largerThan("xl")]: {
                                                fontSize: "4.5vw",
                                            },
                                            margin: 0,
                                            zIndex: 100,
                                            lineHeight: 1,
                                            [theme.fn.smallerThan("md")]: {
                                                fontSize: "6.5vw",
                                            },
                                            [theme.fn.smallerThan("sm")]: {
                                                fontSize: "40px",
                                            },
                                            [theme.fn.smallerThan("xs")]: {
                                                fontSize: "13vw",
                                            },
                                        })}
                                        fw="700"
                                        component="h1"
                                    >
                                        Looking for a <br />great side hustle?
                                    </Text>
                                    <Text
                                        sx={(theme) => ({
                                            zIndex: 100,
                                            fontSize: "20px",
                                            [theme.fn.smallerThan("md")]: {
                                                fontSize: "16px",
                                            },
                                        })}
                                        component="h3"
                                        fw={500}
                                    >
                                        Become a property agent today on your own terms. Find an agency that fits YOUR requirements today!
                                    </Text>
                                    <Group spacing={4}>
                                        <Button
                                            radius="xl"
                                            onClick={() =>
                                                navigate(ctaNavigateLink)
                                            }
                                            sx={(theme) => ({
                                                [theme.fn.smallerThan("xs")]: {
                                                    flex: 1,
                                                },
                                            })}
                                            rightIcon={
                                                <ChevronRight width={14} />
                                            }
                                        >
                                            <Text fz="md">Start Now </Text>
                                        </Button>
                                    </Group>
                                </Stack>
                            </Stack>
                        </Grid.Col>
                        <Grid.Col sm={6} xs={12}>
                            <Stack
                                sx={{
                                    position: "relative",
                                    height: "100%",
                                    width: "100%",
                                }}
                                justify="center"
                            >
                                <Stack
                                    sx={{
                                        width: '100%',
                                        background: "#E4E4E4",
                                        borderRadius: 16,
                                        zIndex: 100,

                                    }}
                                    p={8}
                                    spacing={8}
                                >
                                    <img src="./potential-agent-landing/potential-agent-hero.png" />
                                </Stack>
                            </Stack>
                        </Grid.Col>
                    </Grid>
                </Container>
            </Box>

            <Box py={32}>
                <Container
                    size="1200px"
                // px={sidePadding} 
                >
                    <PartneredAgencies />
                </Container>
            </Box>
            <Box py={32}>
                <Container
                    size="1200px"
                // px={sidePadding} 
                >
                    <Grid>
                        <Grid.Col span={12}>
                            <Text fw="bold" fz={32} >Choose the right team for you</Text>
                        </Grid.Col>
                        <Grid.Col sm={6} xs={12}>
                            <Stack>
                                <Text>We understand that there are a lot of property and agencies out there that are recruiting, but how do you know which one is the right one for you? </Text>
                                <Text>The first thing you have to do is research location, payment terms and compatibility. This would normally take you a long time, not to mention the amount of trial and error that comes with finally finding the right one. </Text>
                            </Stack>
                        </Grid.Col>
                        <Grid.Col sm={6} xs={12}>
                            <Stack>
                                <Text>Propmoth is here to simplify the process by letting the agencies and teams promote their benefits and giving you a chance to browse and choose without too much effort</Text>
                                <Text>We have also verified all of the agencies to make sure that you are talking to the right person that can best guide you through the entire process!</Text>
                            </Stack>
                        </Grid.Col>
                    </Grid>
                </Container>
            </Box>
            <Box>
                <Container
                    size="1200px"
                    // px={sidePadding} 
                    ref={targetRef}
                >
                    <Stack pb={24}>
                        <FeaturedOn />
                        <SupportedBy />
                    </Stack>
                </Container>
            </Box>
        </Box >
    );
}
